const STORE_ID_KEY = 'admin-business-store-id';

function getQueryStoreId() {
  const query = new URLSearchParams(window.location.search);
  const hashQuery = (window.location.hash.split('?')[1] || '').split('&').reduce((result, pair) => {
    const [key, value] = pair.split('=');
    if (key) result[decodeURIComponent(key)] = decodeURIComponent(value || '');
    return result;
  }, {});
  return query.get('storeId') || hashQuery.storeId || '';
}

export function getStoreId() {
  const id = getQueryStoreId() || sessionStorage.getItem('storeId') || localStorage.getItem(STORE_ID_KEY) || process.env.VUE_APP_STORE_ID;
  const value = Number(id);
  if (value > 0) {
    sessionStorage.setItem('storeId', String(value));
    localStorage.setItem(STORE_ID_KEY, String(value));
    return value;
  }
  return 0;
}

export function requireStoreId() {
  const storeId = getStoreId();
  if (!storeId) return Promise.reject(new Error('您还不是会员，请先加入会员！'));
  return Promise.resolve(storeId);
}

export function setStoreId(storeId) {
  const value = Number(storeId);
  if (!value) return;
  sessionStorage.setItem('storeId', String(value));
  localStorage.setItem(STORE_ID_KEY, String(value));
  window.dispatchEvent(new CustomEvent('business-store-change', { detail: { storeId: value } }));
}

export function clearStoreId() {
  const hadStoreId = !!(sessionStorage.getItem('storeId') || localStorage.getItem(STORE_ID_KEY));
  sessionStorage.removeItem('storeId');
  localStorage.removeItem(STORE_ID_KEY);
  if (hadStoreId) window.dispatchEvent(new CustomEvent('business-store-change', { detail: { storeId: 0 } }));
}
